export const insertBreaks = (text?: string | null, interval: number = 50) => {
  if (!text) return null;
  const result = [];
  for (let i = 0; i < text.length; i += interval) {
    result.push(text.slice(i, i + interval));
  }
  return result.map((chunk, index) => (
    <span key={index}>
      {chunk}
      <br />
    </span>
  ));
};